import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '../services/translation.service';

/**
 * Add dir attribute to an element.
 * DONT USE IT ON THE TOP LEVEL ELEMENT IN APP_COMPONENT.HTML BECAUSE FX_FLEX LIB DEPENDS ON IT. INSTEAD SET dir MANUALLY ON THAT TOP LEVEL ELEMENT.
 */
@Directive({
  selector: '[appDirection]'
})
export class DirectionDirective implements OnInit, OnDestroy {

  direction: string;
  element: HTMLElement;
  subscription: Subscription;

  constructor(el: ElementRef, private translationService: TranslationService) {
    this.element = el.nativeElement as HTMLElement;
    this.setDirection(this.translationService.getDirection());
  }

  ngOnInit(): void {
    this.subscription = this.translationService.directionSubject.subscribe(value => {
      this.setDirection(value);
    });
  }

  setDirection(value: string) {
    this.element.dir = value;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
